import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UpdateService } from '@update/infra';

export class VersionInfoQueryHandler {
  private readonly updateService: UpdateService = inject(UpdateService);

  newestVersion(): Observable<string> {
    return this.updateService.newestVersion();
  }

  availableVersions(): Observable<string[]> {
    return this.updateService
      .availableVersions()
      .pipe(map((versions: string[]) => versions.sort((a: string, b: string) => this.compareVersions(b, a))));
  }

  private compareVersions(version1: string, version2: string): number {
    const v1: number[] = version1.split('.').map(Number);
    const v2: number[] = version2.split('.').map(Number);

    for (let i: number = 0; i < Math.max(v1.length, v2.length); i++) {
      const num1: number = v1[i] || 0;
      const num2: number = v2[i] || 0;

      if (num1 > num2) return 1;
      if (num1 < num2) return -1;
    }
    return 0;
  }
}
